export const getRecipeTypeOptions = (recipeTypeSettings) => {
	if (!Array.isArray(recipeTypeSettings)) {
		return [];
	}

	return recipeTypeSettings
		.map((setting) => setting?.recipeType)
		.filter((recipeType) => typeof recipeType === 'string' && recipeType.trim() !== '')
		.map((recipeType) => ({ name: recipeType, value: recipeType }));
};

export const getIngredientName = (smoothiePart) => {
	const name = smoothiePart?.flavor?.name;
	return typeof name === 'string' && name.trim() !== '' ? name : null;
};

export const matchesIngredientFilter = (smoothieParts, filter) => {
	if (!filter || filter.trim().length === 0) {
		return true;
	}

	if (!Array.isArray(smoothieParts)) {
		return false;
	}

	const normalizedFilter = filter.toLowerCase();
	return smoothieParts.some((smoothiePart) => getIngredientName(smoothiePart)?.toLowerCase().includes(normalizedFilter));
};
